import React from 'react';
import type { BookBlockData } from '../data/books';
interface BookBlockProps {
  book: BookBlockData;
  reverse: boolean;
}
export const BookBlock = ({
  book,
  reverse
}: BookBlockProps) => {
  const isLight = book.tone === 'light';
  const bodyColor = isLight ? 'text-white/80' : 'text-gray-700';
  const titleColor = isLight ? 'text-white' : 'text-[#1E1E1E]';
  const chipClass = isLight ? 'bg-white/10 border border-white/20 text-white' : 'bg-white border border-gray-200 text-gray-800';
  const isPair = book.covers.length > 1;
  return <article className="rounded-3xl overflow-hidden shadow-lg" style={{
    backgroundColor: book.bg
  }} data-id="element-123" data-mp="10iliqb3qnhoj">
      <div className={`grid md:grid-cols-2 items-center gap-6 md:gap-10 ${book.feature ? 'p-6 md:p-12' : 'p-6 md:p-10'}`} data-id="element-124" data-mp="1e9gz08gkh125">

        {/* Portadas */}
        <div className={`flex items-end justify-center gap-0 ${reverse ? 'md:order-2' : 'md:order-1'}`} data-id="element-125" data-mp="1o7mw8crfhj0o">
          {book.covers.map((cover, i) => <img key={cover} src={cover} alt={`Portada ${book.title}`} loading="lazy" className={`book-shadow object-contain h-auto ${isPair ? 'w-[46%] max-w-[190px]' : book.feature ? 'w-[72%] max-w-[280px]' : 'w-[62%] max-w-[250px]'} ${isPair && i === 0 ? '-mr-4 md:-mr-6 -rotate-3 z-10' : ''} ${isPair && i === 1 ? 'rotate-3 translate-y-2' : ''} ${!isPair ? '-rotate-2' : ''}`} data-id="element-126" data-mp="1jawe7jw2cdcm" data-mpi={i} />)}
        </div>

        {/* Contenido */}
        <div className={`space-y-3 text-center md:text-left ${reverse ? 'md:order-1' : 'md:order-2'}`} data-id="element-127" data-mp="3fvfixg1ga94j">
          <span className="inline-block font-bold px-3 py-1 rounded-full text-[10px] md:text-xs tracking-wider uppercase" style={{
          backgroundColor: book.accent,
          color: isLight ? '#141110' : '#FFFFFF'
        }} data-id="element-128" data-mp="3kv25ig3651q0">
            {book.badge}
          </span>

          <h3 className={`font-heading text-xl md:text-3xl font-black leading-tight ${titleColor}`} data-id="element-129" data-mp="2i421z763qr3">
            {book.title}
          </h3>

          {book.highlight && <p className="font-heading text-base md:text-xl font-black tracking-wide" style={{
          color: book.accent
        }} data-id="element-130" data-mp="cga54k4pn2xj">
              {book.highlight}
            </p>}

          <p className={`text-[15px] md:text-base leading-relaxed ${bodyColor}`} data-id="element-131" data-mp="23leliw4glvjq">
            {book.desc}
          </p>

          <div className="flex flex-wrap gap-2 justify-center md:justify-start pt-1" data-id="element-132" data-mp="2ib2qq8frhecq">
            {book.chips.map(chip => <span key={chip} className={`text-[11px] md:text-sm font-semibold px-3 py-1.5 rounded-full ${chipClass}`} data-id="element-133" data-mp="2dij1ufbmiwsm">
                {chip}
              </span>)}
          </div>

          {book.note && <p className={`text-xs md:text-sm pt-1 ${isLight ? 'text-white/60' : 'text-gray-500'}`} data-id="element-134" data-mp="2n82olw2gjasr">
              {book.note}
            </p>}
        </div>

      </div>
    </article>;
};